import { render, staticRenderFns } from "./BackgroundShape.vue?vue&type=template&id=d39e42f8"
import script from "./BackgroundShape.vue?vue&type=script&lang=js"
export * from "./BackgroundShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports